import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Timer from "../../../herramientas/Time/setTimer";
import CircularWithValueLabel from "../../../components/CirculeBar/CirculeBar";
import './tableCollapsed.css';






function Row(props) {
    
  const {row,bandera} = props;
  const [open, setOpen] = React.useState(false);
  let totalRegistrado = 0;
  let totalDisponible = 0;
  let ocupacion = 0;

 
    row.remolquesTransportistas.forEach(element => {
      if(element.disponibilidadRemolques){
      totalRegistrado += element.disponibilidadRemolques.total_registrado;
      totalDisponible += element.disponibilidadRemolques.total_disponible;
      
      }
    });  

    if(totalRegistrado > 0){
        ocupacion = (totalRegistrado - totalDisponible) * 100 / (totalRegistrado)
    }


  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.corredor.nombre}
        </TableCell>
        <TableCell align="center">{totalRegistrado}</TableCell>
        <TableCell align="center">
          <div className={`circle-progress ${ocupacion > 80 ? 'high' : ocupacion > 50 ? 'medium' : 'low'}`}>
            <div 
              className="circle-fill" 
              style={{'--percentage': ocupacion}}
            >
              <span>{Math.round(ocupacion)}%</span>
            </div>
          </div>
        </TableCell>
        <TableCell align="center">{!bandera && totalRegistrado == 0 ? row.button :  null}</TableCell>
        
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{boxShadow: "rgb(86 166 216) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset" , backgroundColor:"#3979f94d"}}>Tipo Remolque</TableCell>
                    <TableCell sx={{boxShadow: "rgb(86 166 216) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset" , backgroundColor:"#3979f94d"}}>Registrado</TableCell>
                    <TableCell sx={{boxShadow: "rgb(86 166 216) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset" , backgroundColor:"#3979f94d"}} align="right">Disponible</TableCell>
                    <TableCell sx={{boxShadow: "rgb(86 166 216) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset" , backgroundColor:"#3979f94d"}} align="right">Fecha de Registro</TableCell>
                    <TableCell sx={{boxShadow: "rgb(86 166 216) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset" , backgroundColor:"#3979f94d"}} align="right">Tipo</TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.remolquesTransportistas.map((historyRow) => (
                    <TableRow key={historyRow.idRemolque.idRemolque}>
                      <TableCell sx={{boxShadow: "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px"}} component="th" scope="row">
                        {historyRow.idRemolque.nombre}
                      </TableCell>
                      <TableCell sx={{boxShadow: "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px"}}>{historyRow.disponibilidadRemolques? historyRow.disponibilidadRemolques.total_registrado : 0}</TableCell>
                      <TableCell sx={{boxShadow: "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px"}} align="right">{historyRow.disponibilidadRemolques? historyRow.disponibilidadRemolques.total_disponible : 0}</TableCell>
                      <TableCell sx={{boxShadow: "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px"}} align="right">
                      {historyRow.disponibilidadRemolques? historyRow.disponibilidadRemolques.fechaCreacion : "pendiente" }
                      </TableCell>
                      <TableCell sx={{boxShadow: "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px"}} align="right">
                        {historyRow.tipoCorredor == "L" ? "Local" : "Foraneo"  }
                      </TableCell>
                    
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}






export default function CollapsibleTable(props) {

  const time = new Date();
  const [bandera, setBandera] = React.useState(false);

  const handleFieldChange = (bandera) => {
    setBandera(bandera)
  };


  time.setHours(props.temporizador);
  time.setMinutes(0);
  time.setSeconds(0);
  
  return (
    <div className="compact-table-wrapper">
      <div className="table-card">
        
        
        <TableContainer className="table-content">
          <Table className="custom-table">
            <TableHead>
              <TableRow>
                <TableCell className="expand-col"></TableCell>
                {props.heads.map((head, i) => (
                  <TableCell key={i} className={i === 0 ? 'name-col' : 'center-col'} align={i === 0 ? 'left' : 'center'}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {props.data.map((row) => (
                <Row key={row.corredor.id} row={row} bandera={bandera} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        <div className="card-footer">
          <div className="compact-timer">
            <div className="timer-info">
              <span className="timer-label">Finaliza: {props.temporizador}:00 hrs</span>
              <div className={`status-indicator ${bandera ? 'finished' : 'active'}`}></div>
            </div>
            <div className="timer-display">
              <Timer expiryTimestamp={time} bandera={handleFieldChange}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}